import { BriefcaseBusiness, MapPin } from 'lucide-react'
import { useContext } from 'react'

import EmployerContext from 'components/context/EmployerContext'
import { Badge } from 'slab'
import { getIndustryDisplayText } from 'utils/employer_utils'

import { CollapsibleDataContainer } from '../reusable/CollapsibleDataContainer'
import { CopyFieldRow } from '../reusable/CopyFieldRow'
import TableSkeleton from '../reusable/table/Skeleton'

export default function EmployerBasicInformation () {
  const { profile } = useContext(EmployerContext)

  const heading = (
    <div className='flex items-center space-x-2'>
      <span className='heading-md'>Basic information</span>
      {/* Industry Badge */}
      {profile?.industry && (<Badge type='info' leftIcon={BriefcaseBusiness}>{getIndustryDisplayText(profile?.industry)}</Badge>)}

      {/* State Badge */}
      {profile?.state && (<Badge type='success' leftIcon={MapPin}>{profile?.state}</Badge>)}
    </div>
  )

  const successContent = (
    <dl className='divide-y divide-gray-100 p-4'>
      <CopyFieldRow label='Name' value={profile?.name} />
      <CopyFieldRow label='DBA' value={profile?.dba} />
      <CopyFieldRow label='Industry' value={getIndustryDisplayText(profile?.industry)} />
      <CopyFieldRow label='Address Line 1' value={profile?.address_line1} />
      <CopyFieldRow label='Address Line 2' value={profile?.address_line2} />
      <CopyFieldRow label='City' value={profile?.city} />
      <CopyFieldRow label='State' value={profile?.state} />
      <CopyFieldRow label='ZIP' value={profile?.zip} />
      <CopyFieldRow label='Phone Number' value={profile?.phone_number} isPhoneNumber />
    </dl>
  )

  return (
    <CollapsibleDataContainer
      heading={heading}
      isLoading={!profile}
      error={!profile}
      localStorageKey='employerInformationOpenByDefault'
      loadingContent={<TableSkeleton rowCount={13} columnCount={3} />}
      errorContent={
        <div className='p-4 text-center text-red-500'>
          Error loading employer information
        </div>
      }
      successContent={successContent}
    />
  )
}
